function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.66668 0.666664H1.66668C0.933344 0.666664 0.333344 1.26666 0.333344 2V11.3333H1.66668V2H9.66668V0.666664ZM9.00001 3.33333H4.33334C3.60001 3.33333 3.00668 3.93333 3.00668 4.66666L3.00001 14C3.00001 14.7333 3.59334 15.3333 4.32668 15.3333H11.6667C12.4 15.3333 13 14.7333 13 14V7.33333L9.00001 3.33333ZM4.33334 14V4.66666H8.33334V8H11.6667V14H4.33334Z",
  clipRule: "evenodd"
});

var SvgIcCopy = function SvgIcCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_copy.9f464d13.svg";
export { ForwardRef as ReactComponent };